import { Component, NgModule, OnInit } from '@angular/core';
import { AppConfigService } from '../../services/app-config.service';
import { AppConfig, IAppConfig } from '../../models/core/app-config';
import { OAuthModule } from 'angular-oauth2-oidc';
import { AuthenticationService } from '../../services/authentication.service';
import { PaymentDetailsService } from '../../services/member-details.service';
import { ICommunityMember, IMemberDetails } from '../../models/core/member.model';

@Component({
  selector: 'ben-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})

@NgModule({
  imports: [OAuthModule.forRoot()],
  exports: [OAuthModule]
})

export class NavbarComponent implements OnInit {
  communityMember: ICommunityMember = {
    isCommunityActive: false
  };

  memberDetails: IMemberDetails | undefined;
  private appConfig: IAppConfig = new AppConfig();
  public isAuthenticated = false;
  public isReady = false;
  public isUnauthorized = false;
  public identityClaims: any;
  public mobileMenuToggle: boolean = false;
  timedOutCloser: any;

  constructor(
    private authenticationService: AuthenticationService,
    private paymentDetailsService: PaymentDetailsService,
    private appConfigService: AppConfigService) {    
  }

  ngOnInit(): void {   
    this.appConfigService.getAppConfig().subscribe((data: IAppConfig) => {
      this.appConfig = data;
    });

    this.authenticationService.userLoggedIn().subscribe((data) => {
      if (data) {
        this.paymentDetailsService.getCommunityLink().subscribe(
          (data: boolean) => {
            this.communityMember.isCommunityActive = data;
          },
          (error) => {
            console.error(error);
            this.communityMember.isCommunityActive = false;
          });
        this.paymentDetailsService.getMemberDetails().subscribe(
          data => {
            this.memberDetails = data;
          },
          (error) => {
            console.error(error);
          });
      }
    });
  }
  
  logout() {
    this.authenticationService.userLogout();
  }

  mouseEnter(trigger:any) {
    if (this.timedOutCloser) {
      clearTimeout(this.timedOutCloser);
    }
    trigger.openMenu();
  }

  toggleMobileMenu(toggle: boolean){
    this.mobileMenuToggle = toggle;
  }

  mouseLeave(trigger: any) {
    this.timedOutCloser = setTimeout(() => {
      trigger.closeMenu();
    }, 50);
  }
}
